import { GET_BUSINESS_OVERVIEW_API } from "services/constant";
import { getApiInstance } from "../../ApiInstance";

export const getOverviewData = async () => {
  try {
    const instance = getApiInstance();
    const businessId=sessionStorage.getItem("businessId")
    const response = await instance.get(
      `${GET_BUSINESS_OVERVIEW_API}/getActiveBusiness/${businessId}`
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

export const getActiveBusinessDataApi = async (businessId) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(
      `${GET_BUSINESS_OVERVIEW_API}/getActiveBusiness/${businessId}`
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};
